import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import CommponentOptions from '../plagins/data/commponentOptions';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { createFetchDataServer } from '../../../database/fetchData';

const NAME_ENTITY = 'גוש';

function BlockUpdate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormBlocks.data)

  const { setTitle } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);
  
  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataBlock, getEntitiesByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation()
  const navigate = useNavigate()
  const { value } = location.state || {};
  const [myBlock, setMyBlock] = useState(context?.contextBlocks?.find(item => item?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyBlock(context?.contextBlocks?.find(item => item?.unicId === value?.unicId) || value)
  }, [context?.contextBlocks]);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון גוש`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);
  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([])
  const [blocks, setBlocks] = useState([])

  const myColumns = () => {
    return columns.map(field => {
      let lock = false
      return ({
        ...field,
        disabled: lock ? lock : field.disabled && (myBlock !== undefined),
        required: (field.required || false),
        show: field?.show || false,
      })
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns())
    
    if (myBlock?.unicId) {
      const initialFormValues = myColumns().filter(field => field?.name).reduce((acc, field) => {
        let fieldValue = myBlock[field.name] || '';
        return {
          ...acc,
          [field.name]: fieldValue,
        };
      }, {
        id: myBlock?.id,
        unicId: myBlock?.unicId
      });
      
      setCemeteries(
        context?.contextCemeteries.map(cemetery => CommponentOptions({ value: cemetery?.unicId, label: cemetery?.cemeteryNameHe }))
      )
      const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', myBlock?.cemeteryId)
      ?.filter(block => block?.unicId !== myBlock?.unicId)
      
      setBlocks(blocks)

      setFormValues(initialFormValues);
    }
  }

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => { 
     handleAllDataLoaded() 
    }, []);

  //לוגיקת הזנה בשדות הטופס
  const handleChange = (event) => {
    let newFormValues = formValues
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  }
  // אימות ערכים
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach(field => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (blocks.some(item => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  }
    // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);      

      let res = await addOrUpdateDataBlock(formValues);
      if (res === 200) {
        let updateBlock = context?.contextBlocks?.find((block) => block?.unicId === formValues?.unicId);
        updateBlock = { ...updateBlock, ...formValues };
        let update =  { blockNameHe: updateBlock.blockNameHe, blockNameEn: updateBlock.blockNameEn }

        context?.setContextBlocks((prev) => prev.map((item) => (item.unicId === updateBlock.unicId ? updateBlock : item)));
        context?.setContextPlots((prev) => prev.map((item) => (item.blockId === updateBlock.unicId ? { ...item, ...update } : item)));
        context?.setContextAreaGraves((prev) => prev.map((item) => (item.blockId === updateBlock.unicId ? { ...item, ...update } : item)));
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  if (loadingData) return <LoadingOverlay />

  return (
    <FormTemplate
      title={`עריכת ${NAME_ENTITY}`}
      btn={`עדכן`}
      fields={fieldsWithDynamicDisabled}
      columns={columns}
      formValues={formValues}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      errors={errors}
      options={{ cemeteryId: cemeteries || []}}
    />
  );
}

export default BlockUpdate;